import CS from "./CommuteCalculator";
import {
  theme,
  IconButton,
  Button,
  baseStyles,
  Popover,
} from "@local-logic/core/ui";
import { styled, keyframes } from "styled-components";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-5px);
  }
`;

export const MobileCommuteContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 3;
`;

export const DesktopCommuteContainer = styled.div`
  position: absolute;
  top: ${theme["--ll-spacing-medium"]};
  right: ${theme["--ll-spacing-medium"]};
  z-index: 3;
`;

export const MobileCommuteToggle = styled(IconButton)`
  box-shadow: ${theme["--ll-shadow-medium"]};
  position: absolute;
  bottom: ${theme["--ll-spacing-medium"]};
  right: ${theme["--ll-spacing-medium"]};
`;

export const CommuteCalculator = styled(CS)``;

export const CommuteCalculatorMobile = styled(CS)`
  border-radius: ${theme["--ll-border-radius-small"]}
    ${theme["--ll-border-radius-small"]} 0 0;
  border: 0;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: ${theme["--ll-spacing-x-small"]};
`;

export const DesktopButton = styled(Button)`
  box-shadow: ${theme["--ll-shadow-small"]};
  flex-shrink: 0;

  svg {
    fill: currentColor;
  }
`;

export const DownloadLATButton = styled(Button)`
  background-color: ${baseStyles.colors.neutralColors.colorNeutral100};
  box-shadow: ${theme["--ll-shadow-small"]};
  flex-shrink: 0;

  &:hover {
    background-color: ${baseStyles.colors.neutralColors.colorNeutral95};
  }
`;

export const PopoverContent = styled(Popover.Content)`
  background-color: ${theme["--ll-color-background"]};
  z-index: 1;

  &[data-state="closed"] {
    animation: ${fadeOut} 180ms ease-in-out;
  }

  &[data-state="open"] {
    animation: ${fadeIn} 180ms ease-in-out;
  }
`;
